import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import moment from "moment";

const JobDetails = props => {
  const { job, auth } = props;
  if (!auth.uid) return <Redirect to="/" />;

  if (job) {
    return (
      <div className="container section job-details">
        <div className="card z-depth-0">
          <div className="card-content">
            <h3 className="card-title">{job.jobTitle}</h3>
            <h5>Company</h5>
            <p>{job.companyName}</p>
            <h5>Location</h5>
            <p>{job.location}</p>
            <h5>Industry</h5>
            <p>{job.industry}</p>
            <h5>Function</h5>
            <p>{job.function}</p>
            <h5>Work Type</h5>
            <p>{job.workType}</p>
            <h5>Salary</h5>
            <p>{job.salary} 万円/year</p>

            <h3 className="card-title">Requirements</h3>
            <p>{job.requirements}</p>
            <h3 className="card-title">Description</h3>
            <p>{job.description}</p>

          </div>
          <div className="card-action grey lighten-4 grey-text">
            <div>{moment(job.createdAt.toDate()).calendar()}</div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container center">
        <p>Loading job...</p>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const jobs = state.firestore.data.jobs;
  const job = jobs ? jobs[id] : null;
  return {
    job: job,
    auth: state.firebase.auth
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "jobs" }])
)(JobDetails);
